import { render } from "./ExhibitionPage.vue?vue&type=template&id=d7d0f180&scoped=true"
import script from "./ExhibitionPage.vue?vue&type=script&lang=js"
export * from "./ExhibitionPage.vue?vue&type=script&lang=js"

import "./ExhibitionPage.vue?vue&type=style&index=0&id=d7d0f180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d0f180"]])

export default __exports__